<template>
    <v-card>
        <v-card-title>
            <app-title>{{ currentRound.name }}</app-title>
        </v-card-title>
        <v-card-text>
            <!-- Descripción -->

            <!-- Puntos de control -->
            <v-layout>
                <v-flex>
                    {{ roundDuration }}
                </v-flex>
            </v-layout>
            <v-layout column mb-3>
                <v-flex xs12>
                    <v-card>
                        <v-card-title>
                            <app-sub-title>
                                Puntos de Control ({{ currentRound.control_points.length }})
                            </app-sub-title>
                        </v-card-title>
                        <v-card-text>
                            <v-layout v-for="point in controlPoints" :key="point.id" mb-2>
                                <v-flex
                                    ><app-item-label>Nombre:</app-item-label>
                                    {{ point.name }}</v-flex
                                >
                                <v-flex>
                                    <i class="material-icons" v-if="isConfirmed(point)"> done </i>
                                    <i class="material-icons" v-else> control_camera </i>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-layout column>
                                <v-flex>
                                    <app-control-point-confirm
                                        ref="controlPointForm"
                                        @decode="onDecode"
                                    />
                                </v-flex>
                                <v-flex>
                                    <app-annotation-news
                                        ref="annotationForm"
                                        @save="onSaveAnnotation"
                                    />
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
            <!-- Lista de chequeo -->
            <v-layout column>
                <v-flex xs12>
                    <v-card>
                        <v-card-title>
                            <app-sub-title>
                                Lista de chequeo ({{ currentRound.check_list.length }})
                            </app-sub-title>
                        </v-card-title>
                        <v-card-text>
                            <v-layout>
                                <v-flex xs12>
                                    <small
                                        >Marque todos los items que se cumplen durante la
                                        ronda</small
                                    >
                                </v-flex>
                            </v-layout>
                            <!-- v-for="item in currentRound.check_list" :key="item.id" -->

                            <v-layout v-for="(item, i) in currentRound.check_list" :key="item.id">
                                <v-flex class="mb-2">
                                    <app-checklist-item-answer
                                        @answer="onAnswer"
                                        :item="item"
                                        :index="i + 1"
                                    />
                                    <v-divider></v-divider>
                                </v-flex>
                            </v-layout>
                            <v-layout>
                                <v-flex>
                                    <v-textarea
                                        outlined
                                        filled
                                        label="Notas de la ronda"
                                        v-model="notes"
                                    ></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex>
                    <v-btn v-if="!confirm" color="primary" block @click="() => (confirm = true)"
                        >Finalizar Ronda</v-btn
                    >
                    <v-btn v-else color="success" :disabled="inProgress" block @click="finishRound"
                        >Confirmar Ronda</v-btn
                    >
                    <v-btn color="secondary" block @click="() => $router.go(-1)">Cancelar</v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getDistanceFromCoords } from '../utils/geolocation'
import * as dt from '../utils/datetime'
import ChecklistItemAnswer from '../components/widgets/ChecklistItemAnswer'
import { roundInProgress } from '../dataStructures'

import AnnotationNews from '../components/widgets/AnnotationNews/AnnotationNews'
import ControlPointConfirm from '../components/widgets/ControlPointConfirm/ControlPointConfirm'
import roundRepository from '../repositories/round.repository'

export default {
    components: {
        appChecklistItemAnswer: ChecklistItemAnswer,
        appAnnotationNews: AnnotationNews,
        appControlPointConfirm: ControlPointConfirm,
    },
    data: () => ({
        notes: '',
        confirm: false,
        roundComplete: 0,
        time: 0,
    }),
    computed: {
        ...mapGetters(['lastAnnotations']),
        controlPoints() {
            return this.currentRound.control_points.sort((a, b) => a.order - b.order)
        },
        roundDuration() {
            const duration = moment.duration(this.time)
            return `${String(duration.hours()).padStart(2, '0')}:${String(
                duration.minutes()
            ).padStart(2, '0')}:${String(duration.seconds()).padStart(2, '0')}`
        },
    },
    methods: {
        ...mapActions({
            saveFinishRound: 'finishRound',
        }),
        ...mapMutations({
            setLastAnnotations: 'lastAnnotations',
        }),
        onDecode(point) {
            if (this.roundInProgress.checkPoints.find(item => item.id === point.controlPointId)) {
                toastr.error('Este punto ya se encuentra confirmado')
                return
            }

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(pos => {
                    const { latitude, longitude } = pos.coords
                    this.confirmPoint(point, latitude, longitude)
                })
            }
        },
        setItemAnswer(val, item) {
            const roundInProgress = { ...this.roundInProgress }
            const checklistItems = roundInProgress.checklistItems.slice(0)

            const index = checklistItems.findIndex(el => el.id === item.id)

            const itm = { id: item.id, value: val, answerDate: this.$dt.now() }

            ;-1 !== index && checklistItems.splice(index, 1, itm)

            this.setRoundInProgress({ ...roundInProgress, checklistItems })
        },
        confirmPoint(point, latitude, longitude) {
            const checkpointDate = this.$dt.now()
            const selectedPoint = this.currentRound.control_points.find(
                item => item.id === point.controlPointId
            )

            if (!selectedPoint) return toastr.error('Este punto no pertenece a esta ronda')

            const distance = getDistanceFromCoords(
                selectedPoint.latitude,
                selectedPoint.longitude,
                latitude,
                longitude
            )
            const checkPoints = [...this.roundInProgress.checkPoints]
            checkPoints.push({
                id: selectedPoint.id,
                checkpointDate,
                distance,
                latitude,
                longitude,
            })
            this.setRoundInProgress({ ...this.roundInProgress, checkPoints })
            this.$refs.controlPointForm.close()
        },
        confirmPoint1(point) {
            this.startProcessing()
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    const { latitude, longitude } = position.coords
                    this.openCheckpointForm(point, latitude, longitude)
                })
            }
            this.stopProcessing()
        },
        openCheckpointForm(point, latitude, longitude) {
            const distance = getDistanceFromCoords(
                point.latitude,
                point.longitude,
                latitude,
                longitude
            )

            if (distance > this.config.distanceError)
                toastr.error('No se encuentra en la posición adecuada')

            this.setCurrentPoint({ ...point, latitude, longitude })

            this.$router.push({ name: 'checkpointForm' })
        },
        isConfirmed(point) {
            const index = this.roundInProgress.checkPoints.findIndex(item => item.id === point.id)

            return -1 !== index
        },
        validateRound() {
            const errors = []

            !this.currentRound.id && errors.push('roundId')
            !this.currentRound.service_spot_id && errors.push('structureId')
            !this.user.id && errors.push('userId')
            !this.client.id && errors.push('clientId')
            !this.roundInProgress.startDate && errors.push('startDate')
            !this.roundInProgress.checkPoints && errors.push('checkpoints')
            !this.roundInProgress.checklistItems && errors.push('checklist')
            !['0', '1'].includes(`${this.roundComplete}`) && errors.push('roundComplete')

            return errors
        },
        async finishRound() {
            const errors = this.validateRound()
            if (!_.isEmpty(errors)) return toastr.error(`Errores en ${errors.join(',')}`)
            // Validar que los puntos de control y la lista de chequeo este diligenciada correctamente
            // para poder finalizar la ronda
            if (
                this.roundInProgress.checklistItems.length ===
                    this.currentRound.check_list.length &&
                this.roundInProgress.checkPoints.length === this.currentRound.control_points.length
            )
                this.roundComplete = 1

            if (!this.roundComplete && !this.notes) {
                return toastr.error('Debe especificar por que la ronda no esta completa')
            }

            const formData = new FormData()

            formData.append('roundId', this.currentRound.id)
            formData.append('userId', this.user.id)
            formData.append('startDate', this.roundInProgress.startDate)
            formData.append('endDate', dt.now())
            formData.append('notes', this.notes)
            formData.append('structureId', this.currentRound.service_spot_id)
            formData.append('clientId', this.client.id)
            formData.append('roundComplete', this.roundComplete)

            // Si la ronda pudo ser persistida previamente se envía el id
            !!this.roundInProgress.id && formData.append('roundInstanceId', this.roundInProgress.id)

            // Puntos de control
            this.roundInProgress.checkPoints.map(point => {
                formData.append(`checkpoints[${point.id}][id]`, point.id)
                formData.append(`checkpoints[${point.id}][notes]`, point.notes)
                formData.append(`checkpoints[${point.id}][latitude]`, point.latitude)
                formData.append(`checkpoints[${point.id}][longitude]`, point.longitude)
                formData.append(`checkpoints[${point.id}][checkpointDate]`, point.checkpointDate)

                // point.pictures.map((pic, i) => (formData.append(`checkpoints[${point.id}][pictures][${i}]`, pic)));
            })

            // Items de la lista de chequeo
            this.roundInProgress.checklistItems.map((item, i) => {
                formData.append(`checklist[${i}][questionId]`, item.checklistItemId)
                formData.append(`checklist[${i}][answerId]`, item.answerId)
                formData.append(`checklist[${i}][answerDate]`, item.answerDate)
            })

            // Anotaciones que no fueron guardadas inmediatamente
            this.roundInProgress.annotations.map((item, i) => {
                formData.append(`annotations[${i}][what]`, item.what)
                formData.append(`annotations[${i}][who]`, item.who)
                formData.append(`annotations[${i}][how]`, item.how)
                formData.append(`annotations[${i}][latitude]`, item.latitude)
                formData.append(`annotations[${i}][longitude]`, item.longitude)

                !!item.pictures &&
                    item.pictures.map(pic => {
                        formData.append(`annotation[${i}][pictures][]`, pic)
                    })
            })

            this.startProcessing()
            const data = await this.saveFinishRound(formData)
            this.stopProcessing()

            if (data.status) {
                toastr.success('Ronda finalizada')
                this.setLastRound(data.roundInstance)
                this.setCurrentRound(null)
                this.setRoundInProgress(roundInProgress)
                localStorage.removeItem('bitacorapp_round_in_progress')
                this.$router.push({ name: 'home' })
            } else {
                toastr.error(data.msg)
            }
        },
        onAnswer(answer) {
            const roundInProgress = { ...this.roundInProgress }
            const checklistItems = [...roundInProgress.checklistItems]

            const index = checklistItems.findIndex(
                item => item.checklistItemId === answer.checklistItemId
            )

            if (-1 === index) {
                checklistItems.push(answer)
            } else {
                checklistItems.splice(index, 1, answer)
            }

            this.setRoundInProgress({ ...roundInProgress, checklistItems })
        },
        async onSaveAnnotation(annotation) {
            if (navigator.geolocation) {
                await navigator.geolocation.getCurrentPosition(pos => {
                    const { latitude, longitude } = pos.coords
                    const theAnnotation = { ...annotation, latitude, longitude }
                    if (!!this.roundInProgress.id) {
                        return this.saveAnnotation(theAnnotation)
                    }
                    return this.storeAnnotation(theAnnotation)
                })
            } else {
                // Si el dispositivo no tiene activada la localizacion
                const theAnnotation = { ...annotation, latitude: 0, longitude: 0 }
                if (!!this.roundInProgress.id) {
                    return this.saveAnnotation(theAnnotation)
                }
                return this.storeAnnotation(theAnnotation)
            }
        },
        // Si la ronda pudo ser iniciada se envia la anotación inmediatamente
        // al servidor para evitar al máximo perdida de información
        async saveAnnotation(annotation) {
            try {
                const formData = new FormData()

                Object.keys(annotation).map(key => {
                    if (Array.isArray(annotation[key])) {
                        annotation[key].map(item => formData.append(`${key}[]`, item))
                    } else {
                        formData.append(key, annotation[key])
                    }
                })

                formData.append('roundInstanceId', this.roundInProgress.id)
                formData.append('structureId', this.currentRound.service_spot_id)
                formData.append('userId', this.user.id)
                formData.append('clientId', this.client.id)

                const rr = { ...roundRepository }

                const { data } = await rr.saveAnnotation(formData)
                if (data.status) {
                    const maxRows = 10
                    const annotations = this.lastAnnotations.filter(
                        (item, index) => this.lastAnnotations.length < maxRows || index !== 0
                    )
                    annotations.push(data.annotation)
                    this.setLastAnnotations(annotations)
                    toastr.success('Novedad reportada')
                    this.$refs.annotationForm.close()
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                toastr.error(err.message)
            }
        },
        // Si la ronda no pudo ser creadad por problemas de conectividad
        // se almacena en memoria la novedad para ser enviada al final
        storeAnnotation(annotation) {
            const roundInProgress = { ...this.roundInProgress }
            const annotations = [...roundInProgress.annotations]
            annotations.push(annotation)
            this.setRoundInProgress({ ...roundInProgress, annotations })
            this.$refs.annotationForm.close()
            // this.roundInProgress.annotations.push(annotation);
        },
        // loadRoundInProgress() {
        //     debugger;
        //     if(!this.roundInProgress || Object.keys(this.roundInProgress).length === 0) {
        //         if(!!localStorage.getItem('bitacorapp_round_in_progress')) {
        //             const roundInProgress = JSON.parse(localStorage.getItem('bitacorapp_round_in_progress'));
        //             this.setRoundInProgress(roundInProgress);
        //         }
        //     }
        // }
    },
    mounted() {
        // this.loadRoundInProgress();
        setInterval(() => {
            this.time = moment().diff(this.roundInProgress.startDate)
        }, 1000)
    },
}
</script>
